import { render } from "./MBusiness.vue?vue&type=template&id=0df7b1fb"
import script from "./MBusiness.vue?vue&type=script&lang=js"
export * from "./MBusiness.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__